import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import Main from "./Main";
import { msalConfig } from "./auth/msal/MsalAuthConfig";
import { ConfigProvider } from "antd";
import theme from "./theme";
import "./styles/page-heading.scss";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <BrowserRouter>
      <ConfigProvider theme={theme}>
   <Main />
      </ConfigProvider>
      </BrowserRouter>
    </Provider>
  </MsalProvider>
);